import { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { BlockParameters, useBlocker } from 'hooks/routes';
import { useModalState } from './useModalState';

export const useUnsaveChangesModal = <T extends object>(
  form: UseFormReturn<T>,
  onReset: VoidFunction,
) => {
  const [targetLocation, setTargetLocation] = useState<BlockParameters | null>(null);
  const navigate = useNavigate();
  const unsaveChangesModal = useModalState();

  const { isDirty, isSubmitSuccessful, isSubmitting } = form.formState;

  const onRequestClose = () => {
    unsaveChangesModal.closeModal();
  };

  const onDiscardClick = () => {
    onReset();
    unsaveChangesModal.closeModal();

    //Necessary to allow time for updating dependencies in useBlocker
    setTimeout(() => {
      if (targetLocation) navigate(targetLocation.location.pathname);
    }, 0);
  };

  const onBlocker = (nav: BlockParameters) => {
    setTargetLocation(nav);
    unsaveChangesModal.openModal();
  };

  const onCancelClick = () => {
    setTargetLocation(null);
    unsaveChangesModal.openModal();
  };

  useBlocker(onBlocker, isDirty && !(isSubmitSuccessful || isSubmitting));

  return {
    onDiscardClick,
    onRequestClose,
    isOpen: unsaveChangesModal.isModalVisible,
    onCancelClick,
  };
};
